// extracted by mini-css-extract-plugin
export var editButton = "_kc-0";